module.exports = __webpack_public_path__ + "img/positive-result-variant.2ee09418.svg";